export enum Variant {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  SECONDARY = 'secondary',
  INFO = 'info',
  DANGER = 'danger'
}

export interface Props
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant,
  leading?: React.ReactNode,
  trailing?: React.ReactNode,
  loading?: boolean,
  outline?: boolean
}

export interface FloatingButtonProps extends Props {
  parentElement?: React.RefObject<HTMLElement>
}
